import { PureComponent } from 'react';
import { Field } from 'redux-form';

import MileageControl from '../Control';

export default class MileageField extends PureComponent {
  render() {
    return <Field {...this.props} component={MileageControl} />;
  }
}
